import React from "react";
import axios from 'axios';
import './css/bootstrap.min.css';
import './css/style.css';
import config from './config/config.json';
import LoadingSpinner from './LoadingSpinner.jsx';
// import { RootCloseWrapper } from "react-overlays";

var HostName = config.HostName;
// this.show = () => this.setState({ show: true });
// this.hide = () => this.setState({ show: false });
class AppMgmt extends React.Component {
    state = {
        isUserLoggedIn: false,
        vendors: [],
        getapps: [],
        versions: [],
        selectedApp: "",
        selectedVersion: "",
        selectedVendor: "",
        selectedAppType: "",
        responseString: "",
        loading: false,
        className: '',
        getVersions: [],
        drive: ''
        //show: false
    }
    Reset() {  
        var dropDown = document.getElementById("wgtmsr");  
        dropDown.selectedIndex = 0;  
    }
    versionHistory(appName){
        this.setState({ loading: true });
        var url = HostName + "/api/v1/versionhistory/app/"+appName;
        fetch(url,{
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("accessToken"),
                "Content-Type":"text/plain",
                "Content-Disposition": 'attachment',
                "filename":appName+".txt"
            }
            }).then(resp => {
                if (resp.status === 200) {
                    this.setState({ responseString: "Successfully fetched version history" });
                    return resp.json();
                } else if (resp.status === 404) {
                    console.log("Download version history failed with 404 ");
                    this.setState({ responseString: "Download version history failed with 404" });
                } else if (resp.status === 401 || resp.status === 403) {
                    console.log("Download version history failed with 4**");
                    this.setState({ isUserLoggedIn: false })
                }
            }).then(responseURL => {
                if(responseURL!=null && responseURL.data!=null){
                    fetch(responseURL.data, {
                        method: 'GET',
                      }).then(function(resp) {
                        return resp.blob();
                      }).then(function(blob) {
                        const newBlob = new Blob([blob], { type: "text/plain", charset: "UTF-8" })
                  
                        // IE doesn't allow using a blob object directly as link href
                        // instead it is necessary to use msSaveOrOpenBlob
                        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                          window.navigator.msSaveOrOpenBlob(newBlob);
                          return;
                        }
                        const data = window.URL.createObjectURL(newBlob);
                        const link = document.createElement('a');
                        //link.dataType = "json";
                        link.href = data;
                        link.download = appName+".txt";
                        link.dispatchEvent(new MouseEvent('click'));
                        setTimeout(function () {
                          // For Firefox it is necessary to delay revoking the ObjectURL
                          window.URL.revokeObjectURL(data), 60
                        });
                      });
                    // var FileSaver = require('file-saver');
                    // FileSaver.saveAs(responseURL.data, appName+".txt");
                }
                //window.open(responseURL.data);
                //file.pipe(responseURL.data);
                this.setState({ selectedApp: '' });
                this.Reset();
                this.setState({ loading: false })
            }).catch(error => {
                this.setState({ responseString: "Unable to fetch version history/APP not selected." });
                this.Reset();
                this.setState({ selectedApp: '' });
                this.setState({ loading: false })
                this.setState({ className: 'text-danger' })
                console.log("Unable to download version history: "+error);
            });
    }

    handleChangeAppsDropdown(e) {
        this.setState({ loading: true });
        this.setState({ responseString: '' });
        if (e.target.value === "select") {
            this.setState({ versions: [] });
            this.setState({ selectedApp: e.target.value });
            this.setState({ loading: false });
        } else {
            let appType = e.target.value.split('/')[e.target.value.split('/').length - 3];
            let appName = e.target.value.split('/')[e.target.value.split('/').length - 2];
            this.setState({ selectedAppType: e.target.value.split('/')[e.target.value.split('/').length - 3] });
            this.setState({ selectedApp: e.target.value.split('/')[e.target.value.split('/').length - 2] });
            this.setState({ selectedVersion: 'select' });
            var url = HostName + "/api/v1/apptype/";
            fetch(url + appType + "/app/" + appName + "/versions", {
                headers: {
                    "Authorization": "Bearer " + localStorage.getItem("accessToken")
                }
            })
                .then(response => {
                    if (response.status === 200) {
                        console.log("Fetching apptype/versions successful");
                        return response.json();
                    } else if (response.status === 401 || response.status === 403) {
                        console.log("Fetching apptype/versions failed with 4**");
                        this.setState({ isUserLoggedIn: false })
                    }
                })
                .then(versionslist => {
                    this.setState({ versions: versionslist.data });
                    this.setState({ loading: false })
                }).catch(error => {
                    console.log("Fetching apptype/versions failed." + error);
                    this.setState({ versions: [] })
                    this.setState({ loading: false });
                });
        }
    }

    handleDelete(vendorName, appName) {
        this.setState({ loading: true });
        var url = HostName + "/api/v1/deleteapp";
        axios.delete(url, {
            data: {
                "vendorname": vendorName,
                "appname": appName
            },
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("accessToken")
            }, timeout: config.TimeOut
        })
            .then(delresp => {
                console.log("Deleting application successful");
                this.renderGrid(this.state.selectedVendor, this.state.selectedApp, "NA");
                this.setState({ responseString: "Deleting application successful" });
                this.setState({ loading: false })
            })
            .catch(error => {
                console.log("Deleting application failed with an exception");
                this.setState({ responseString: "No Application present to delete" });
                this.setState({ loading: false });
            });
    }

    handleChangeVersionsDropdown(e) {
        this.setState({ loading: true });
        this.setState({ selectedVersion: e.target.value });
        this.setState({ loading: false });
    }

    handleChangeVendorsDropdown(e) {
        this.setState({ loading: true });
        this.setState({ selectedVendor: e.target.value });
        this.getDriveFromVendor(e.target.value);
        this.setState({ loading: false });
    }

    getDriveFromVendor(vendorName) {
        this.state.vendors.map((option) => {
            if (option.name === vendorName) {
                return this.setState({ drive: option.drive });
            } else {
                return null
            }
        })
    }

    loadDeployedAppsGrid() {
        this.setState({ loading: true });
        this.setState({ getVersions: [] });
        var url3 = HostName + "/api/v1/getDeployedversions";
        fetch(url3, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("accessToken")
            }
        })
            .then(response => {
                if (response.status === 200) {
                    console.log("Fetching deployed apps successful");
                    return response.json();
                } else if (response.status === 401 || response.status === 403) {
                    console.log("Fetching deployed apps failed with 4**");
                    this.setState({ isUserLoggedIn: false })
                }
            })
            .then(versionslist => {
                this.setState({ getVersions: versionslist });
                this.setState({ loading: false });
            }).catch(error => {
                console.log("Fetching latestVersions/apps failed." + error);
                this.setState({ versions: [] })
                this.setState({ loading: false });
            });
    }

    copyfiles(e) {
        this.setState({ loading: true });
        e.preventDefault();
        if (this.state.selectedVersion === 'none') {
            this.handleDelete(this.state.selectedVendor, this.state.selectedApp);
        } else {
            var splittedVersion = this.state.selectedVersion.split('/')[this.state.selectedVersion.split('/').length - 2]
            var url = HostName + "/api/v1/copy";
            if (this.validateFields()) {
                axios.put(url, {
                    "vendorname": this.state.selectedVendor,
                    "appType": this.state.selectedAppType,
                    "appName": this.state.selectedApp,
                    "version": splittedVersion,
                    "drive": this.state.drive
                }, {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem("accessToken")
                        }, timeout: config.TimeOut
                    }).then(resp => {
                        this.renderGrid(this.state.selectedVendor, this.state.selectedApp, splittedVersion);
                        this.setState({ responseString: resp.data.message });
                        this.setState({ loading: false })
                        this.setState({ className: 'text-success' })
                        console.log("Copy successful");
                    }).catch(error => {
                        this.renderGrid(this.state.selectedVendor, this.state.selectedApp, splittedVersion);
                        this.setState({ responseString: error.response.data.message });
                        this.setState({ loading: false })
                        this.setState({ className: 'text-danger' })
                        console.log("Copy failed.");
                    });
            } else {
                this.setState({ responseString: "Please select all the required(*) files." });
                this.setState({ loading: false });
                this.setState({ className: 'text-danger' })
            }
        }
    }

    renderGrid(vendor, app, version) {
        let temp = this.state.getVersions;
        for (var i = 0; i < temp.length; i++) {
            if (temp[i].AppName === app) {
                let tempDep = temp[i].DeployedVersions;
                tempDep[vendor] = version;
                break;
            }
        }
        this.setState({ getVersions: temp });
    }

    validateFields = () => {
        if (this.state.selectedVendor === undefined || this.state.selectedVendor === '' || this.state.selectedVendor === 'select'
            || this.state.selectedAppType === undefined || this.state.selectedAppType === '' || this.state.selectedAppType === 'select'
            || this.state.selectedApp === undefined || this.state.selectedApp === '' || this.state.selectedApp === 'select'
            || this.state.selectedVersion === undefined || this.state.selectedVersion === '' || this.state.selectedVersion === 'select') {
            console.log("Field validation failed");
            return false;
        } else {
            console.log("Field validation successful");
            return true;
        }
    }

    navigateToLogin(e) {
        this.setState({ loading: true });
        e.preventDefault();
        this.props.history.push('/');
        this.setState({ loading: false });
    }

    resetFields() {
        this.setState({ selectedApp: "" });
        this.setState({ selectedVersion: "" });
        this.setState({ selectedVendor: "" });
        this.setState({ selectedAppType: "" });
        this.setState({ drive: "" });
    }

    componentDidMount() {
        this.setState({ loading: true });
        if (localStorage.getItem("accessToken") !== null && localStorage.getItem("accessToken") !== undefined) {
            this.setState({ isUserLoggedIn: true })
        }
        var url = HostName + "/api/v1/vendors";
        fetch(url, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("accessToken")
            }
        })
            .then(response => {
                if (response.status === 200) {
                    console.log("Fetching vendors successful");
                    return response.json();
                } else if (response.status === 401 || response.status === 403) {
                    console.log("Fetching vendors failed with 4**");
                    this.setState({ isUserLoggedIn: false })
                }
                else if (response.status === 404) {
                    console.log("Fetching vendors failed with 404");
                    return response.json();
                }
            })
            .then(data => {
                this.setState({ vendors: data.data });
                this.setState({ loading: false });
            }).catch(error => {
                this.setState({ vendors: error.data })
                this.setState({ loading: false });
                this.setState({ responseString: error })
                this.setState({ className: 'text-danger' })
                console.log("Fetching vendors failed with an exception.");
            });
        this.setState({ loading: true });
        var url2 = HostName + "/api/v1/getapps";
        fetch(url2, {
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("accessToken")
            }
        })
            .then(response => {
                if (response.status === 200) {
                    console.log("Fetching apps success");
                    return response.json();
                } else if (response.status === 401 || response.status === 403) {
                    console.log("Fetching apps failed with 4**");
                    this.setState({ isUserLoggedIn: false })
                }
            })
            .then(appslist => {
                this.setState({ getapps: appslist.data });
                this.setState({ loading: false });
            }).catch(error => {
                this.setState({ getapps: [] })
                this.setState({ loading: false });
                console.log("Fetching apps failed with an exception." + error);
            });

        this.loadDeployedAppsGrid();
        this.resetFields();
    }

    render() {
        if (this.state.isUserLoggedIn) {
            return (
                <div className="container">
                    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />
                    <div className="scroller">
                        <table className="table table-light appmgmt-table">
                            <thead className='thead-dark'>
                                <tr>
                                    <th className='text-center'>App</th>
                                    <th className='text-center'>Version History</th>
                                    <th className='text-center'>Latest Version</th>
                                    {this.state.vendors.map((vendors => {
                                        return (
                                            <th className='text-center' key={vendors.name}>
                                                {vendors.name}
                                            </th>
                                        )
                                    }))}
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.getVersions.map((versions => {
                                    return (
                                        <tr className='text-center' key={versions.AppName}>
                                            <td className='text-center'> {versions.DisplayName}</td>
                                            <td><a className='kinda-link' onClick={(e) =>this.versionHistory(versions.AppName)}>View</a></td>
                                            <td className='text-center'> {versions.LatestVersion !== undefined ? versions.LatestVersion : 'NA'}</td>
                                            {Object.keys(versions.DeployedVersions).map(function (key) {
                                                return <td className='text-center' key={key}>{versions.DeployedVersions[key]}</td>;
                                            })}
                                        </tr>
                                    )
                                }))}
                            </tbody>
                        </table>
                        </div>
                    <h3>Choose an App, Version and Vendor to which the App has to be deployed.</h3>
                    <br />
                    <form>
                    <div id="listVendors">
                        <table className="table table-hover" id="tabledata">
                            <thead className='thead-dark'>
                                <tr>
                                    <th className='text-center'>FIELD</th>
                                    <th className='text-center'>VALUE</th>
                                </tr>
                            </thead>
                            <tbody className='text-center'>
                                <tr>
                                    <td className='text-center'>APP <span className="text-danger">*</span></td>
                                    <td className='text-center'>
                                        <select id="wgtmsr" onChange={this.handleChangeAppsDropdown.bind(this)} onSelect={this.handleChangeAppsDropdown.bind(this)}>
                                            <option key="select" value="select">--Select--</option>
                                            {this.state.getapps.map((option) =>
                                                <option key={option.prefix} value={option.prefix}>{option.folderName}</option>)}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-center'>VERSION <span className="text-danger">*</span></td>
                                    <td className='text-center'>

                                        <select id="wgtmsr" value={this.state.selectedVersion} onSelect={this.handleChangeVersionsDropdown.bind(this)} onChange={this.handleChangeVersionsDropdown.bind(this)}>
                                            <option key="select" value="select">--Select--</option>
                                            <option key="none" value="none">None</option>
                                            {this.state.versions.map((option) => <option key={option.prefix} value={option.prefix}>{option.folderName}</option>)}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-center'>VENDOR <span className="text-danger">*</span></td>
                                    <td className='text-center'>

                                        <select id="wgtmsr" onChange={this.handleChangeVendorsDropdown.bind(this)}>
                                            <option key="select" value="select">--Select--</option>
                                            {this.state.vendors.map((option) => <option key={option.name} value={option.name}>{option.name}</option>)}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td className='text-center'>DRIVE <span className="text-danger"></span></td>
                                    <td className='text-center'>
                                        {this.state.drive}
                                    </td>
                                </tr>
                                <tr>
                                    <td align="right">
                                        <button type="button" className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={this.copyfiles.bind(this)}>
                                            Deploy
                                        </button>
                                    </td>
                                    <td align="left">
                                        <button type="Reset" className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={this.resetFields.bind(this)}>
                                            Reset
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </form>
                    <div>
                        {
                            this.state.loading ? <LoadingSpinner /> : null
                        }
                    </div>
                    <br></br>
                    <div>
                        <p className={this.state.className}>{this.state.responseString}</p>
                    </div>

                </div>
            );
        }
        else {
            return (
                <div>
                    <p><font color="red">Session Invalid. Please Login to continue.</font></p>
                    <button type="button" className="btn btn-primary" data-toggle="button" aria-pressed="false" autoComplete="off" onClick={this.navigateToLogin.bind(this)} >Login</button>

                </div>
            );
        }
    }
}

export default AppMgmt;


// WEBPACK FOOTER //
// ./src/AppMgmt.js